
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/denuncias-e-fraudes",
      function () {
        return require("private-next-pages/denuncias-e-fraudes.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/denuncias-e-fraudes"])
      });
    }
  